export default {
  bps_server: 'https://bps.arsenalbio.com:8443',
  annotation_server: 'https://bps.arsenalbio.com:9090',
  websocket_server: 'wss://bps.arsenalbio.com:9091',
};
